const TaskCenterRouters = [
  {
    path: '/TaskCenter',
    name: 'TaskCenter',
    component: () => import('@/views/TaskCenter/taskCenter.vue'),  // 懒加载
    meta: {
      isCorrectPage: true,
      auth: false
    }
  },//任务中心 

]

export default TaskCenterRouters;